/**
 * Functionality for sticky call action bar.
 *
 * @module feature/StickyCallActionBar
 */

/**
 * Changes sticky call action bar position
 *
 * @memberof module:feature/StickyCallActionBar
 * @version 1.0.0
 */
class StickyCallActionBar {
    /**
     * Upgrades DOM element.
     * @param {DOMElement} element DOM element to upgrade.
     */
    constructor(element) {
        this.$element = $(element);
        this.marker = document.querySelector('.sticky-call-action-bar-pin-marker');
    }

    /**
     * Change Sticky Call to Action Bar position if Footer is in the Viewport.
     */
    init() {
        this.setStickyCallActionBarPosition();

        window.addEventListener('scroll', () => {
            this.setStickyCallActionBarPosition();
        });
    }

    setStickyCallActionBarPosition() {
        for (const $element of this.$element) {
            const scrollPositionFromTop = this.marker.getBoundingClientRect().top;

            if (scrollPositionFromTop <= 0) {
                $element.classList.add('sticky-to-top');
                this.marker.style.height = $element.getBoundingClientRect().height + 'px';
            } else {
                $element.classList.remove('sticky-to-top');
                this.marker.style.height = 0;
            }
        }
    }
}

// register to Component Handler
window.ComponentHandler.register({
    constructor: StickyCallActionBar,
    classAsString: 'StickyCallActionBar',
    cssClass: 'js-sticky-contact-action-bar',
});

export default StickyCallActionBar;
